"use client";

import { ActionPanel } from "@/components/common/action-panel";
import { createPath } from "@/service/routing/routing";
import { useState } from "react";
import { EbookActionWithSubscriptionList } from "@/components/ebook/ebook-action-with-subscription-list";
import { Button } from "@/components/ui/button";
import { DownloadIcon, LoaderIcon, LogInIcon } from "lucide-react";

export const EbookActionBlock = ({
  action,
  ebook,
}: {
  action: EbookActionsWidgetVM;
  ebook: EbookVM;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name } = ebook;
  const {
    subscriptionListWidget,
    released,
    downloadUrl,
    title,
    message,
    buttonName,
  } = action;

  const { alreadySubscribed, slug } = subscriptionListWidget ?? {};

  const onlyDownload = !subscriptionListWidget || alreadySubscribed;

  const heading = released
    ? "Pobierz swojego e-booka"
    : "Potwierdź swój etap drogi zawodowej";
  const paragraph = released
    ? `E-book "${name}" już dostępny!`
    : "Zapisz się na listę zainteresowanych, żeby jako pierwszy/a dostać informację o premierze ebooka.";

  return (
    <div className="my-8">
      <ActionPanel
        image={ebook.image}
        title={"Wiedza dla Ciebie!"}
        button={
          buttonName ? (
            <>
              <Button
                variant={"blue"}
                onClick={() => {
                  if (!onlyDownload) {
                    setIsOpen(true);
                  }

                  if (onlyDownload) {
                    window.open(downloadUrl);
                  }
                }}
                disabled={loading}
              >
                {loading && <LoaderIcon className="animate-spin" />}
                {!loading && released ? <DownloadIcon /> : <LogInIcon />}
                {buttonName}
              </Button>
            </>
          ) : (
            <></>
          )
        }
        message={`E-book “${ebook.name}”`}
      />

      {!onlyDownload && (
        <EbookActionWithSubscriptionList
          state={{
            apiSubscribe: createPath(
              "subscription_list.default.subscribe_api",
              {
                slug,
              },
            ),
            apiUnsubscribe: createPath(
              "subscription_list.default.unsubscribe_api",
              { slug },
            ),
            saveToNewsletter: true,
            subscribed: alreadySubscribed as boolean,
            heading,
            paragraph: paragraph,
            options: released
              ? {
                  download: downloadUrl,
                  subscriptionInfo:
                    "Pobierając e-booka, zapisujesz się na listę z informacjami o jego aktualizacjach. Nie przegap!",
                }
              : {},
          }}
          close={() => setIsOpen(false)}
          isOpen={isOpen}
        />
      )}
    </div>
  );
};
